import { useEffect, useState } from "react";
import { Star, Check, EyeOff, Trash2 } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { Stars } from "@/components/reviews/Stars";

export function ReviewInbox() {
  const { t } = useLang();
  const [items, setItems] = useState(null);
  useEffect(() => { api.allReviews().then(setItems).catch(() => setItems([])); }, []);
  const set = async (id, status) => { await api.setReview(id, status); setItems((all) => all.map((r) => (r.id === id ? { ...r, status } : r))); };
  const del = async (id) => { if (!window.confirm(t("Delete this review for good?"))) return; await api.deleteReview(id); setItems((all) => all.filter((r) => r.id !== id)); };
  const waiting = items?.filter((r) => r.status === "pending").length || 0;
  return (
    <div className="card" data-testid="review-inbox">
      <div className="donate-head"><Star size={18} /><div className="card-name">{t("Reviews to approve")}</div>
        {waiting > 0 && <span className="inbox-badge" data-testid="review-inbox-count">{waiting}</span>}</div>
      {items === null ? <div className="card-sub">…</div> : !items.length ? <div className="card-sub" data-testid="review-inbox-empty">{t("No reviews yet.")}</div> : items.map((r) => (
        <div key={r.id} className="review-item" data-testid={`review-admin-${r.id}`}>
          <div className="review-top"><Stars value={r.stars} size={14} testid={`review-admin-stars-${r.id}`} /><b>{r.name || t("Anonymous")}</b>
            <span className={`review-status st-${r.status}`} data-testid={`review-admin-status-${r.id}`}>{t(r.status === "approved" ? "Public" : r.status === "hidden" ? "Hidden" : "Waiting")}</span></div>
          <p className="review-text" data-no-metric="">{r.text}</p>
          <div className="review-actions">
            {r.status !== "approved" && <button type="button" className="ghost-btn" data-testid={`review-approve-${r.id}`} onClick={() => set(r.id, "approved")}><Check size={14} />{t("Approve")}</button>}
            {r.status !== "hidden" && <button type="button" className="ghost-btn" data-testid={`review-hide-${r.id}`} onClick={() => set(r.id, "hidden")}><EyeOff size={14} />{t("Hide")}</button>}
            <button type="button" className="ghost-btn danger-ghost" data-testid={`review-delete-${r.id}`} onClick={() => del(r.id)}><Trash2 size={14} />{t("Delete")}</button>
          </div>
        </div>
      ))}
    </div>
  );
}
